export const MARK_PRICE_CHART_UPDATE = 'MARK_PRICE_CHART_UPDATE';
export const CHART_SUBSCRIPTION_PAYLOAD = 'CHART_SUBSCRIPTION_PAYLOAD';
export const TOGGLE_FULL_SCREEN_MODE = 'TOGGLE_FULL_SCREEN_MODE';
export const SET_CHART_ACTIVE_TAB = 'SET_CHART_ACTIVE_TAB';
export const SET_CHART_SCROLLING = 'SET_CHART_SCROLLING';
export const SET_CHART_FROZEN = 'SET_CHART_FROZEN';
export const TOGGLE_PLACE_ORDER_SECTION = 'TOGGLE_PLACE_ORDER_SECTION';
export const SET_CHART_COUNT = 'SET_CHART_COUNT';
export const SET_CLOSE_POSITION_POPUP = 'SET_CLOSE_POSITION_POPUP';
